import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FeedbackModal } from './FeedbackModal'

export function SiteNav() {
  const [showFeedback, setShowFeedback] = useState(false)
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('theme')
      if (stored === 'dark' || stored === 'light') return stored
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark'
    }
    return 'light'
  })

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
    localStorage.setItem('theme', theme)
  }, [theme])

  return (
    <>
    <div className="border-b border-gray-200 dark:border-neutral-700">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 text-xl font-semibold text-gray-900 dark:text-white hover:opacity-80 transition-opacity"
        >
          <svg className="w-6 h-6 shrink-0" viewBox="0 0 32 32" aria-hidden="true">
            <g stroke="currentColor" strokeWidth="2">
              <circle cx="5" cy="16" r="3.5" className="fill-white dark:fill-neutral-900"/>
              <circle cx="16" cy="6" r="3.5" className="fill-white dark:fill-neutral-900"/>
              <circle cx="16" cy="16" r="3.5" className="fill-white dark:fill-neutral-900"/>
              <circle cx="16" cy="26" r="3.5" className="fill-white dark:fill-neutral-900"/>
              <circle cx="27" cy="16" r="3.5" className="fill-white dark:fill-neutral-900"/>
            </g>
          </svg>
          <span>a<span className="text-blue-600 dark:text-blue-400">risk</span></span>
        </Link>
        <div className="flex items-center gap-5">
          <Link
            to="/about"
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
          >
            About
          </Link>
          <Link
            to="/faq"
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
          >
            FAQ
          </Link>
          <Link
            to="/blog"
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
          >
            Blog
          </Link>
          <button
            onClick={() => setShowFeedback(true)}
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
          >
            Feedback
          </button>
          <button
            onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
            className="text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? (
              <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="5" />
                <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
              </svg>
            ) : (
              <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
    <FeedbackModal isOpen={showFeedback} onClose={() => setShowFeedback(false)} />
    </>
  )
}
